import { ReactComponent as ForwardIcon } from "app/assets/images/icons/chevron-right-lg.svg";
import React from "react";
import { Link } from "react-router";
import { NZD } from "utils/currency";

const determineTextColour = (
  statusDetails: {
    verb: string;
    type: string;
    status: string;
  },
  valueNote: string,
) => {
  if (!statusDetails || valueNote !== statusDetails.status)
    return "text__colour--primary";
  if (statusDetails?.type === "alert") {
    return "text__colour--crimson";
  }
  if (statusDetails?.type === "success") {
    return "text__colour--green";
  }

  return "text__colour--primary";
};

type ItemProps = {
  href: string;
  label: string;
  labelNote: string;
  value: string;
  valueNote?: string;
  statusDetails?: { verb: string; type: string; status: string };
};

export const Item: React.FC<ItemProps> = ({
  href,
  label,
  labelNote,
  value,
  valueNote,
  statusDetails,
}) => {
  return (
    <Link
      to={href}
      state={{ previousPath: window.location.pathname }}
      className="customer_tools_list__link bill-list-item__link"
    >
      <div
        data-testid="item-left-text-wrapper"
        className={`${statusDetails?.type === "alert" || statusDetails?.type === "warning" ? `customer_tools_list__left_text customer_tools_list__left_text--${statusDetails?.type}` : ""}`}
      >
        <p>
          <span className="sr-only">Bill for </span>
          {label}
          <br />
          <small className="customer_tools_list__text text__colour--muted">
            {labelNote}
          </small>
        </p>
      </div>
      <div className="customer_tools_list__right_aligned_text_icon_content">
        <div className="customer_tools_list__right_aligned_text_icon_content--text">
          <p className="customer_tools_list__text">
            {NZD.format(parseFloat(value))}
            {valueNote && (
              <span>
                <br />
                <b
                  className={`customer_tools_list__text ${determineTextColour(statusDetails, valueNote)} small`}
                >
                  {valueNote}
                </b>
              </span>
            )}
          </p>
        </div>
        <ForwardIcon />
      </div>
    </Link>
  );
};
